import React from "react";

export default function Wrapper({ children, className }) {
  return (
    <section className="flex justify-content-center align-items-center my-4 md:my-6 py-6 px-0 md:px-5">
      <div className={`${className}`}>{children}</div>
    </section>
  );
}
